document.addEventListener('DOMContentLoaded', function() {
  const carousels = document.querySelectorAll('.botanicals-carousel');
  
  carousels.forEach(carousel => {
    // Only run on mobile
    if (window.innerWidth > 749) return;
    
    const track = carousel.querySelector('.carousel-track');
    const slides = Array.from(carousel.querySelectorAll('.carousel-slide'));
    const prevBtn = carousel.querySelector('.carousel-prev');
    const nextBtn = carousel.querySelector('.carousel-next');
    const dotsContainer = carousel.parentElement.querySelector('.carousel-dots');
    
    if (!track || slides.length === 0) return;
    
    let currentSlide = 0;
    const totalSlides = slides.length;
    
    console.log('🚀 Initializing carousel with', totalSlides, 'slides');
    console.log('Container:', carousel.querySelector('.carousel-track-container'));
    console.log('Track:', track);
    console.log('Slides:', slides);
    
    // Set up track and slides
    function setupCarousel() {
      const containerWidth = carousel.querySelector('.carousel-track-container').offsetWidth;
      
      // Set track width to fit all slides
      track.style.width = `${containerWidth * totalSlides}px`;
      track.style.display = 'flex';
      track.style.transition = 'transform 0.3s ease';
      
      // Set each slide to full container width
      slides.forEach((slide, index) => {
        slide.style.width = `${containerWidth}px`;
        slide.style.flexShrink = '0';
        console.log(`Slide ${index} width set to ${containerWidth}px`);
      });
      
      // Position at first slide
      track.style.transform = `translateX(0px)`;
      currentSlide = 0;
      
      updateNavigation();
      createDots();
    }
    
    // Move to specific slide
    function goToSlide(slideIndex) {
      if (slideIndex < 0 || slideIndex >= totalSlides) return;
      
      const containerWidth = carousel.querySelector('.carousel-track-container').offsetWidth;
      const moveDistance = slideIndex * containerWidth;
      
      track.style.transform = `translateX(-${moveDistance}px)`;
      currentSlide = slideIndex;
      
      console.log(`Moving to slide ${slideIndex}, translateX(-${moveDistance}px)`);
      
      updateNavigation();
      updateDots();
    }
    
    // Update navigation buttons
    function updateNavigation() {
      if (prevBtn) {
        prevBtn.disabled = currentSlide === 0;
        prevBtn.style.opacity = currentSlide === 0 ? '0.3' : '1';
      }
      
      if (nextBtn) {
        nextBtn.disabled = currentSlide === totalSlides - 1;
        nextBtn.style.opacity = currentSlide === totalSlides - 1 ? '0.3' : '1';
      }
    }
    
    // Create pagination dots
    function createDots() {
      if (!dotsContainer || totalSlides <= 1) {
        if (dotsContainer) dotsContainer.style.display = 'none';
        return;
      }
      
      dotsContainer.innerHTML = '';
      dotsContainer.style.display = 'flex';
      
      for (let i = 0; i < totalSlides; i++) {
        const dot = document.createElement('button');
        dot.className = 'carousel-dot';
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => goToSlide(i));
        dotsContainer.appendChild(dot);
      }
      
      updateDots();
    }
    
    // Update dots
    function updateDots() {
      const dots = dotsContainer?.querySelectorAll('.carousel-dot');
      if (!dots) return;
      
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentSlide);
      });
    }
    
    // Event listeners
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        console.log('Previous clicked, current slide:', currentSlide);
        goToSlide(currentSlide - 1);
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        console.log('Next clicked, current slide:', currentSlide);
        goToSlide(currentSlide + 1);
      });
    }
    
    // Touch support
    let startX = 0;
    let isDragging = false;
    
    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });
    
    track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
    });
    
    track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      
      const endX = e.changedTouches[0].clientX;
      const diffX = startX - endX;
      
      if (Math.abs(diffX) > 50) {
        if (diffX > 0 && currentSlide < totalSlides - 1) {
          goToSlide(currentSlide + 1);
        } else if (diffX < 0 && currentSlide > 0) {
          goToSlide(currentSlide - 1);
        }
      }
    });
    
    // Initialize
    setupCarousel();
    
    // Handle resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (window.innerWidth > 749) {
          // Desktop - clean up
          track.style.width = '';
          track.style.display = '';
          track.style.transform = '';
          track.style.transition = '';
          slides.forEach(slide => {
            slide.style.width = '';
            slide.style.flexShrink = '';
          });
          if (dotsContainer) dotsContainer.style.display = 'none';
        } else {
          // Mobile - reinitialize
          setupCarousel();
        }
      }, 250);
    });
    
    console.log('Carousel initialized successfully');
  });
});

// Shopify theme editor support
if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    setTimeout(() => {
      const event = new Event('DOMContentLoaded');
      document.dispatchEvent(event);
    }, 100);
  });
}